<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section v-if="isDataFetched" class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">ワンストップガイドトップ管理</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <!-- 検索条件 -->
      <div class="">
        <table style="width: 100%">
          <thead>
            <th style="width: 10%"></th>
            <th style="width: 25%"></th>
            <th style="width: 5%"></th>
            <th style="width: 55%"></th>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                カテゴリ
              </td>
              <td>
                <select
                  id="bannerArea"
                  class="form-control"
                  v-model="selectedCategory"
                  v-bind:disabled="!isSearchMode"
                >
                  <option
                    v-for="item in categoryList"
                    :key="item.categoryId"
                    :value="item.categoryId"
                  >
                    {{ item.categoryName }}
                  </option>
                </select>
              </td>
              <td class="form-control-title">
                <button
                  type="button"
                  name="btnSearch"
                  class="btn btn-primary"
                  @click="onSearch"
                  v-bind:disabled="!isSearchMode"
                >
                  検索
                </button>
              </td>
              <td>
                <button
                  type="button"
                  name="btnClearH"
                  class="btn btn-footer btn-primary"
                  @click="onClear"
                >
                  クリア
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div>
        <table style="width: 100%; margin-bottom: 5px">
          <thead>
            <th style="width: 30%"></th>
            <th style="width: 8%"></th>
            <th style="width: 52%"></th>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  id="titleSerch"
                  placeholder="絞込キーワードを入力してください"
                  type="text"
                  maxlength="255"
                  class="form-control"
                  v-model="searchText"
                  v-bind:disabled="isSearchMode"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">選択</th>
              <th class="col_id" style="text-align: center">ID</th>
              <th class="col_subCategory">サブカテゴリ</th>
              <th class="col_title">タイトル</th>
              <th class="col_keisaiKikan">掲載期間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in narrowList" :key="item.contentsId">
              <td data-name="mSelection" style="text-align: center">
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                />
              </td>
              <td data-name="mContentsId" style="text-align: center">
                {{ item.contentsId }}
              </td>
              <td data-name="mSubCategoryName">{{ item.subCategoryName }}</td>
              <td data-name="mTitle">{{ item.title }}</td>
              <td style="text-align: center" data-name="mHyoujiKIkan">
                {{ item.keisaikikanStart }} ～{{ item.keisaikikanEnd }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-inline flex-container">
          <div class="form-group"></div>
          <div class="form-group">
            <button
              type="button"
              name="btnUpdate"
              class="btn btn-middle btn-primary"
              v-bind:disabled="isSearchMode"
              @click="addDispList"
            >
              表示対象に追加
            </button>
          </div>
        </div>
      </div>
      <br />
      <div class="">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_id">ID</th>
              <th class="col_subCategory">サブカテゴリ</th>
              <th class="col_title">タイトル</th>
              <th class="col_keisaiKikan">掲載期間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in dispList" :key="item.contentsId">
              <td data-name="mBtnUpdate" style="text-align: center">
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  @click="removeFromDisplayList(item.contentsId)"
                >
                  削除
                </button>
              </td>
              <td data-name="mContentsId" style="text-align: center">
                {{ item.contentsId }}
              </td>
              <td data-name="mSubCategoryName">{{ item.subCategoryName }}</td>
              <td data-name="mTitle">{{ item.title }}</td>
              <td style="text-align: center" data-name="mHyoujiKIkan">
                {{ item.keisaikikanStart }} ～{{ item.keisaikikanEnd }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-inline flex-container">
          <div class="form-group"></div>
          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>

            <button
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              @click="onClear"
            >
              クリア
            </button>
            <button
              type="button"
              name="btnUpdate"
              class="btn btn-footer btn-primary"
              v-bind:disabled="isSearchMode"
              @click="onCommit"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";

interface Category {
  categoryId: string;
  categoryName: string;
}

interface OnStopGide {
  selection: boolean;
  displayTargetFlag: boolean;
  categoryId: string;
  contentsId: string;
  subCategoryId: string;
  subCategoryName: string;
  title: string;
  keisaikikanStart: string;
  keisaikikanEnd: string;
  displayOrder: number;
}

interface CommitItem {
  categoryId: string;
  contentsId: string;
}

class OneStopGideKanriConstants {
  // ------------------------------------------------------------
  // バナー登録・変更 一覧画面の処理モード
  static readonly PROCESSING_MODE_SERACH = "SERACH"; // 検索条件入力
  static readonly PROCESSING_MODE_RESULT = "RESULT"; // 検索結果表示

  static readonly API_URL_INITIAL_DISPLAY =
    "/api/OneStopGideKanri/getInitialData";

  static readonly API_URL_GET_CONTENTS_LIST =
    "/api/OneStopGideKanri/getContentsList";

  static readonly API_URL_CREATE_OSG_KANRI =
    "/api/OneStopGideKanri/createDisplayTarget";
}

export default defineComponent({
  name: "OneStopGideMaintenanceComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const selectedCategory = ref("");
    const processingMode = ref("");
    const categoryList = ref<Category[]>([]); // カテゴリリスト
    const { logoutUser } = useUserStore();
    const oneStopGideList = ref<OnStopGide[]>([]);
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const searchText = ref("");
    const dispList = ref<OnStopGide[]>([]); // チェックされたアイテムを格納するリスト

    /**
     * 表示対象フラグがfalseのものだけを抽出するcomputedプロパティ
     */
    const filteredList = computed(() => {
      return oneStopGideList.value.filter((item) => !item.displayTargetFlag);
    });

    /**
     * 表示対象候補リストから指定された絞込キーワードで絞り込むプロパティ
     */
    const narrowList = computed(() => {
      const text = searchText.value.toLowerCase(); // 小文字変換で大文字小文字を無視
      return filteredList.value.filter((item) =>
        item.title.toLowerCase().includes(text)
      );
    });

    /**
     * 表示対象候補リストで選択されているデータの件数
     */
    const selectedItemCount = computed(() => {
      return narrowList.value.filter((item) => item.selection).length;
    });

    /**
     * ワンストップガイド管理テーブル登録対象データのリスト
     */
    const commitList = computed<CommitItem[]>(() => {
      return dispList.value.map((item) => ({
        categoryId: item.categoryId,
        contentsId: item.contentsId,
      }));
    });

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      outputDebugLogs("ワンストップガイド管理 初期処理");

      try {
        // 初期処理時はTrue
        isInitError.value = true;
        processingMode.value = OneStopGideKanriConstants.PROCESSING_MODE_SERACH;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
        }

        // 初期表示データ取得
        const response = await apiAuthClient.post(
          OneStopGideKanriConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
          }
        );

        categoryList.value = response.data.categoryListData;

        // 検索条件入力モードの場合
        selectedCategory.value = categoryList.value[0].categoryId;

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * コンテンツ一覧取得
     */
    const getContentsList = async () => {
      const response = await apiAuthClient.post(
        OneStopGideKanriConstants.API_URL_GET_CONTENTS_LIST,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: selectedCategory.value,
        }
      );

      // レスポンスを保持
      oneStopGideList.value = response.data.oneStopGideList;

      oneStopGideList.value.forEach((item) => {
        if (item.displayTargetFlag) {
          // dispListに追加
          dispList.value.push(item);
        }
        item.selection = false; // 全ての選択をリセット
      });

      // displayOrderの昇順でソート
      dispList.value.sort((a, b) => a.displayOrder - b.displayOrder);

      // 処理モード設定
      processingMode.value = OneStopGideKanriConstants.PROCESSING_MODE_RESULT;

      // 一番上にスクロール
      scrollToTop();
    };

    /**
     * 検索条件入力モード判定
     */
    const isSearchMode = computed(() => {
      return (
        processingMode.value == OneStopGideKanriConstants.PROCESSING_MODE_SERACH
      );
    });

    /**
     * 検索ボタン押下
     */
    const onSearch = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チエック
      if (!selectedCategory.value) {
        errorMessage.value = formatMessage(messages.ERR_0001, "カテゴリ");
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // ワンストップガイド一覧情報取得
      try {
        await getContentsList();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      try {
        processingStore.isProcessing = true;

        const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // 管理者トップへ遷移
        router.push("/kanrisya-top");
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";

        if (!isSearchMode.value) {
          // 検索結果表示モードの場合

          // 検索結果クリア
          oneStopGideList.value = [];
          dispList.value = [];
          searchText.value = "";

          // 検索条件入力モードを設定
          processingMode.value =
            OneStopGideKanriConstants.PROCESSING_MODE_SERACH;

          // 一番上にスクロール
          scrollToTop();
        } else {
          // 検索条件入力モードの場合
          selectedCategory.value = categoryList.value[0].categoryId;
        }
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 表示対象に追加
     */
    const addDispList = async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";
        if (selectedItemCount.value == 0) {
          errorMessage.value = formatMessage(messages.ERR_0003, "表示候補");

          // 一番上にスクロール
          scrollToTop();
          return;
        }

        // searchedList内でselectionがtrueのもののdisplayTargetFlagを変更
        narrowList.value.forEach((item) => {
          if (item.selection) {
            item.displayTargetFlag = true; // チェックされたもののフラグをtrueに変更

            // dispListに追加
            dispList.value.push(item);
          }
          item.selection = false; // 全ての選択をリセット
        });
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    // データ削除処理
    const removeFromDisplayList = (contentsId: string) => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 1. displayListから該当データを削除
        dispList.value = dispList.value.filter(
          (item) => item.contentsId !== contentsId
        );

        // 2. 検索対象リスト(searchedList)のdisplayTargetFlagをfalseに戻す
        const targetItem = oneStopGideList.value.find(
          (item) => item.contentsId === contentsId
        );
        if (targetItem) {
          targetItem.displayTargetFlag = false;
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 確定処理
     */
    const onCommit = async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";
        if (dispList.value.length == 0) {
          errorMessage.value = formatMessage(messages.ERR_0004, "表示対象");

          // 一番上にスクロール
          scrollToTop();
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "変更", "確定")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 登録API実行
        await apiAuthClient.post(
          OneStopGideKanriConstants.API_URL_CREATE_OSG_KANRI,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            contentsList: commitList.value,
          }
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "変更内容", "確定"));
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        //更新処理
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      selectedCategory,
      isSearchMode,
      categoryList,
      onSearch,
      onBack,
      onClear,
      getContentsList,
      searchText,
      narrowList,
      dispList,
      addDispList,
      removeFromDisplayList,
      onCommit,
    };
  },
});
</script>
<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
/* 折り返し表示用スタイル */
td[data-wrap] {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 0; /* 必要に応じて幅を設定 */
}
.col_selection {
  width: 6%;
}
.col_id {
  width: 7%;
}
.col_subCategory {
  width: 17%;
}
.col_title {
  width: 50%;
}
.col_keisaiKikan {
  width: 20%;
}

.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-middle {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 200px;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  vertical-align: middle;
}
.form-control-title {
  text-align: left;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.gray-background {
  background-color: rgb(177, 177, 177);
}
.unchanged {
  background-color: #fffdbf;
}
</style>
